export default value => {
  const val = parseInt(value, 10);
  if (Number.isNaN(val)) {
    return null;
  }
  return val;
};
